import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export enum Severity {
    Error = "error",
    Warning = "warning",
    Info = "info",
    Success = "success",
}

interface AlertState {
    alerts: Array<Alert>;
    alertIndex: number;
}

interface Alert {
    message: string;
    severity: Severity;
    index: number;
}

const initialState: AlertState = {
    alerts: [],
    alertIndex: 1,
};

const alertsSlice = createSlice({
    name: "alerts",
    initialState,
    reducers: {
        addAlert(state, action: PayloadAction<Omit<Alert, "index">>) {
            state.alerts.unshift({
                ...action.payload,
                index: state.alertIndex++,
            });
        },
    },
});

export const { addAlert } = alertsSlice.actions;
export const alertsReducer = alertsSlice.reducer;
